import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';

import { localeData } from '../../../locales/data';
import { formatMessageHelper } from '../../../shared/helpers/internationalization';

import './EditorCloseTabModal.scss';

interface EditorCloseTabModalProps {
  handleCancelModalCloseTab: () => void;
  handleModalCloseTab: () => void;
  modalType?: string;
}

export const EditorCloseTabModalIntl = ({
  handleCancelModalCloseTab,
  handleModalCloseTab,
  intl,
  modalType,
}: EditorCloseTabModalProps & InjectedIntlProps) => (
  <div className="modal__content--closeTab">
    <header className="modal__header">
      <h3 className="modal__title">{formatMessageHelper(intl, `editorMain.${modalType}.title`)}</h3>
    </header>
    <div className="editor-close-tab__modal--content">
      <div>
        {intl.formatMessage({
          id: `editorCloseTabModal.${modalType}.firstParagraph`,
          defaultMessage: localeData.en[`editorCloseTabModal.${modalType}.firstParagraph`],
        })}
      </div>
      <div className="editor-close-tab__modal--section--text">
        {intl.formatMessage({
          id: `editorCloseTabModal.${modalType}.secondParagraph`,
          defaultMessage: localeData.en[`editorCloseTabModal.${modalType}.secondParagraph`],
        })}{' '}
      </div>
      <div className="editor-close-tab__modal-section--buttons">
        <button onClick={handleCancelModalCloseTab} className="button button--md  button--secondary">
          {intl.formatMessage({
            id: `editorCloseTabModal.${modalType}.button.cancel`,
            defaultMessage: localeData.en[`editorCloseTabModal.${modalType}.button.cancel`],
          })}
        </button>
        <button onClick={handleModalCloseTab} className="button button--md  button--primary">
          {intl.formatMessage({
            id: `editorCloseTabModal.${modalType}.button.close`,
            defaultMessage: localeData.en[`editorCloseTabModal.${modalType}.button.close`],
          })}
        </button>
      </div>
    </div>
  </div>
);

export const EditorCloseTabModal = injectIntl(EditorCloseTabModalIntl);
